import React, {Suspense} from "react";
import "./App.css";
import "./css/login.css";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import LogoutPage from "./pages/logout/Logout";
import {refreshToken} from "./api/authentication/RefreshTokenAPI";
import TopicSpecializationPage from "./pages/specialization/topic/TopicSpecializationPage";
import ConfirmPasswordPage from "./pages/account/ConfirmPasswordPage";
import FeedbackPage from "./pages/feedback/Feedback";
import LoginPage from "./pages/account/LoginPage";
import RegisterPage from "./pages/account/RegisterPage";
import ForgotPasswordPage from "./pages/account/ForgotPasswordPage";
import AuthorSpecializationPage from "./pages/specialization/author/AuthorSpecializationPage";
import {KeywordClusterPage} from "./pages/specialization/keyword/cluster/KeywordClusterPage";
import {KeywordClusterReport} from "./pages/specialization/keyword/cluster/KeywordClusterReport";
import {SiteSpecializationPage} from "./pages/specialization/site/SiteSpecializationPage";
import {UpgradePage} from "./pages/upgrade/UpgradePage";
import {ComingSoon} from "./pages/comingsoon/ComingSoon";
import {UserInfoPage} from "./pages/account/UserInfoPage";
import {TutorialPage} from "./pages/tutorial/TutorialPage";
import {WhatsNewPage} from "./pages/specialization/whatsnew/WhatsNewPage";
import {isLogin} from "./api/authentication/AuthenticationAPI";
import RequireAccessPage from "./pages/comingsoon/RequireAccessPage";
import TrendingPage from "./pages/TrendingPage";
import ChartPage from "./pages/statistics/overall/OverallPage";
import SiteStatisticsPage from "./pages/statistics/sites/SiteStatisticsPage";
import TopicPage from "./pages/statistics/topic/TopicPage";
import WordCloudPage from "./pages/statistics/keyword/KeywordStatisticsPage";
import {Box} from "@mui/material";
import {KeywordPortraitPage} from "./pages/specialization/keyword/KeywordPortraitPage";
import {KeywordComparePage} from "./pages/specialization/keyword/compare/KeywordComparePage";
import FacebookManagementPage from "./pages/social/facebook/FacebookManagementPage";
import KeywordCampaignsPage from "./pages/specialization/keyword/campaign/KeywordCampaignsPage";
import {KeywordCampaignDetailPage} from "./pages/specialization/keyword/campaign/KeywordCampaignDetailPage";
import {ForumManagementPage} from "./pages/social/forum/ForumManagementPage";
import {GoogleManagementPage} from "./pages/social/google/GoogleManagementPage";
import {GoogleQueryDetailPage} from "./pages/social/google/GoogleQueryDetailPage";
import {SettingDomainPage} from "./pages/settings/domain/SettingDomainPage";
import {SettingAlertPage} from "./pages/settings/alert/SettingAlertPage";
import {SettingGeneralPage} from "./pages/settings/general/SettingGeneralPage";
import TouchPointsPage from "./pages/specialization/touchpoints/TouchPointsPage";
import BrandingManagementPage from "./pages/specialization/branding/BrandingManagementPage";
import SidebarV2 from "./components/SidebarV2";

import NavigationPage from "./pages/NavigationPage";
import KeywordClusterDetail from "./pages/specialization/keyword/cluster/KeywordClusterDetail";
import AssistantPage from "./pages/specialization/assistant/AssistantPage";
import Dashboard from "./pages/dashboard/Dashboard";

const MainLayout = () => {
  return (
    <div className="App">
      {/*<Sidebar/>*/}
      <SidebarV2/>
      <Box sx={{marginLeft: "230px"}}>
        <Routes>
          {/*<Route path="/" element={<NavigationPage/>}/>*/}
          <Route path="/" element={<Dashboard/>}/>
          <Route path="/assistant" element={<AssistantPage />}/>
          <Route path="/trending" element={<TrendingPage/>}/>
          <Route path="/statistics/keyword" element={<WordCloudPage/>}/>
          <Route path="/statistics/overview" element={<ChartPage/>}/>
          <Route path="/statistics/sites" element={<SiteStatisticsPage/>}/>
          <Route path="/statistics/topic" element={<TopicPage/>}/>
          {/* <Route
            path="/specialization/keyword"
            element={<KeywordSpecializationPage />}
          /> */}
          <Route
            path="/specialization/topic"
            element={
              isLogin() ? (
                <TopicSpecializationPage/>
              ) : (
                <RequireAccessPage accountLevel="NEWS+"/>
              )
            }
          />
          <Route
            path="/specialization/author"
            element={
              isLogin() ? (
                <AuthorSpecializationPage/>
              ) : (
                <RequireAccessPage accountLevel="NEWS+"/>
              )
            }
          />
          <Route
            path="/specialization/cluster"
            element={
              isLogin() ? (
                <KeywordClusterPage/>
              ) : (
                <RequireAccessPage accountLevel="NEWS+"/>
              )
            }
          ></Route>
          <Route
            path="/specialization/compare"
            element={
              isLogin() ? (
                <KeywordComparePage/>
              ) : (
                <RequireAccessPage accountLevel="NEWS+"/>
              )
            }
          />
          <Route
            path="/specialization/sites"
            element={
              isLogin() ? (
                <SiteSpecializationPage/>
              ) : (
                <RequireAccessPage accountLevel="NEWS+"/>
              )
            }
          ></Route>
          <Route
            path="/specialization/cluster/:id"
            element={
              isLogin() ? (
                <KeywordClusterDetail />
              ) : (
                <RequireAccessPage accountLevel="NEWS+"/>
              )
            }
          ></Route>
          <Route
            path="/specialization/portrait"
            element={
              isLogin() ? (
                <KeywordPortraitPage/>
              ) : (
                <RequireAccessPage accountLevel="PREMIUM"/>
              )
            }
          />
          <Route
            path="/specialization/whatsnew"
            element={
              isLogin() ? (
                <WhatsNewPage/>
              ) : (
                <RequireAccessPage accountLevel="NEWS+"/>
              )
            }
          />
          <Route
            path="/specialization/branding"
            element={
              isLogin() ? (
                <BrandingManagementPage/>
              ) : (
                <RequireAccessPage accountLevel="NEWS+"/>
              )
            }
          />
          <Route
            path="/specialization/campaigns"
            element={
              isLogin() ? (
                <KeywordCampaignsPage/>
              ) : (
                <RequireAccessPage accountLevel="NEWS+"/>
              )
            }
          />
          <Route
            path="/specialization/campaign/:id"
            element={<KeywordCampaignDetailPage/>}
          />
          <Route
            path="/specialization/touchpoints"
            element={
              isLogin() ? (
                <TouchPointsPage/>
              ) : (
                <RequireAccessPage accountLevel="NEWS+"/>
              )
            }
          ></Route>
          <Route
            path="/social-network/facebook"
            element={isLogin() ? (<FacebookManagementPage/>) : (
              <RequireAccessPage accountLevel="SOCIAL+"/>
            )}
          />
          <Route path="/social-network/tiktok" element={<ComingSoon/>}/>
          <Route
            path="/social-network/google"
            element={
              isLogin() ? (
                <GoogleManagementPage/>
              ) : (
                <RequireAccessPage accountLevel="FORUM+"/>
              )
            }
          />
          <Route
            path="/social-network/google/query/:id"
            element={
              isLogin() ? (
                <GoogleQueryDetailPage/>
              ) : (
                <RequireAccessPage accountLevel="FORUM+"/>
              )
            }
          />
          <Route
            path="/social-network/forum"
            element={
              isLogin() ? (
                <ForumManagementPage/>
              ) : (
                <RequireAccessPage accountLevel="FORUM+"/>
              )
            }
          ></Route>
          <Route path="/feedback" element={<FeedbackPage/>}/>
          <Route
            path="/settings/domain"
            element={
              isLogin() ? (
                <SettingDomainPage/>
              ) : (
                <RequireAccessPage accountLevel="FORUM+"/>
              )
            }
          />
          <Route
            path="/settings/alert"
            element={
              isLogin() ? (
                <SettingAlertPage/>
              ) : (
                <RequireAccessPage accountLevel="FORUM+"/>
              )
            }
          />
          <Route
            path="/settings/general"
            element={
              isLogin() ? (
                <SettingGeneralPage/>
              ) : (
                <RequireAccessPage accountLevel="FORUM+"/>
              )
            }
          />
          <Route path="/support/tutorial" element={<TutorialPage/>}/>
          <Route path="/logout" element={<LogoutPage/>}/>
          <Route path="/upgrade" element={<UpgradePage/>}/>
          <Route path="/account/info" element={<UserInfoPage/>}/>
        </Routes>
      </Box>
    </div>
  );
};

function App() {
  refreshToken();
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="App">
            Chỗ này cần thêm component loading
          </div>
        }
      >
        <Routes>
          <Route path="/login" element={<LoginPage/>}/>
          <Route path="/register" element={<RegisterPage/>}/>
          <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
          <Route path="/confirm-password" element={<ConfirmPasswordPage/>}/>
          <Route path="/*" element={<MainLayout/>}/>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
